import React from 'react';

const Hero = () => (
  <section
    id="home"
    className="bg-bg-primary px-10 pt-16 pb-12"
    style={{ borderBottom: "0.5px solid #e0ddd8" }}
  >
    <p
      className="text-terracotta font-inter mb-6"
      style={{
        fontSize: "11px",
        letterSpacing: "0.18em",
        textTransform: "uppercase",
      }}
    >
      Cultural Worker · Researcher · Curator · Digital Communications
    </p>

    <h1
      className="font-playfair text-ink mb-6"
      style={{ fontSize: "52px", fontWeight: 400, lineHeight: 1.1 }}
    >
      Manal
      <br />
      Khan
    </h1>

    <p
      className="text-muted"
      style={{
        fontSize: "16px",
        lineHeight: 1.75,
        maxWidth: "580px",
        borderLeft: "2px solid #D85A30",
        paddingLeft: "1.25rem",
        marginBottom: "2rem",
      }}
    >
      I work at the intersection of journalism, cinema, and human rights —
      producing, curating, and theorising media as a tool for solidarity across
      South Asian diasporas and beyond. With 3+ years in digital communications,
      I build campaigns that reach 40K+ audiences internationally.
    </p>

    <a
      href="/ManalKhan_CV.pdf"
      download="ManalKhan_CV.pdf"
      className="font-inter text-muted hover:text-ink transition-colors duration-200"
      style={{
        fontSize: "11px",
        letterSpacing: "0.14em",
        textTransform: "uppercase",
        borderBottom: "0.5px solid #e0ddd8",
        paddingBottom: "1px",
      }}
    >
      Download CV
    </a>
  </section>
);

export default Hero;
